import type { JobStatus } from '@/types'

export const JOB_STATUS_BADGE_STYLE: Record<
  JobStatus,
  { backgroundColor: string; color: string }
> = {
  to_plan: { backgroundColor: '#fef3c7', color: '#8a5405' },
  planned: { backgroundColor: '#e7e9ef', color: '#171a20' },
  assigned: { backgroundColor: '#dbeafe', color: '#1d44b3' },
  in_progress: { backgroundColor: '#fff1ea', color: '#ff5a1f' },
  completed: { backgroundColor: '#d1fae5', color: '#065f46' },
  cancelled: { backgroundColor: '#fecaca', color: '#7f1d1d' },
}
